import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AnswerListService } from "../../master-services/master-answer-list-services/answerList.service";
import { ChecklisAreatService } from "../../master-services/check-list/checklistArea.service";
import { UserService } from "../../master-services/User/user.service";
import { RestService } from "../../master-services/Rest/rest.service";
import { Router } from "@angular/router";
import swal from "sweetalert2";
import { error } from "console";
import { T } from "@angular/core/src/render3";

@Component({
  selector: "app-master-area",
  templateUrl: "./master-answer-list.component.html",
  styleUrls: ["./master-answer-list.component.scss"],
})
export class MasterAnswerList implements OnInit {
  myForm: FormGroup;

  areaId: any;
  answerLists: any;
  checklists: any;
  checklistForm: FormGroup;
  userSelects: any;
  userLists: any;

  lisChek: number;
  addUserForm: FormGroup;

  answerForm: FormGroup;

  ////

  // selectedBusinessId: any;
  // selectedBranchOfficeId: any;
  customers: any;
  branchOffices: any;

  ////

  constructor(
    private AnswerListService: AnswerListService,
    private ChecklisAreatService: ChecklisAreatService,
    private UserService: UserService,
    private router: Router,
    private restService: RestService
  ) {
    this.areaId = Number(localStorage.getItem("idarea"));
    //*********** (i) Administrar listas de chequeo  *************** */
    const idlist = new FormControl("0");
    const nameList = new FormControl("", Validators.required);
    const description = new FormControl("");
    this.indexByIdArea(this.areaId);
    this.lisChek = Number(localStorage.getItem("lisChek"));
    this.checklistForm = new FormGroup({
      idlist: idlist,
      nameList: nameList,
      description: description,
    });

    //*********** (f) Administrar listas de chequeo  *************** */

    ///.Checklis
    const idUser = new FormControl("", Validators.required);
    const place = new FormControl("", Validators.required);
    const dateRange = new FormControl(false);
    const passingDate = new FormControl("", Validators.required);
    const untilDate = new FormControl("");
    const selectedBusinessId = new FormControl("", Validators.required);
    const selectedBranchOfficeId = new FormControl("");
    this.addUserForm = new FormGroup({
      idUser: idUser,
      place: place,
      dateRange: dateRange,
      passingDate: passingDate,
      untilDate: untilDate,
      selectedBusinessId: selectedBusinessId,
      selectedBranchOfficeId: selectedBranchOfficeId,
    });

    ///.Checklis

    //AnswerListController

    const id = new FormControl("0");
    const name = new FormControl("", Validators.required);
    this.answerForm = new FormGroup({
      id: id,
      name: name,
    });
    //AnswerListController
  }

  ngOnInit() {
    this.getUser();
    this.getCustomers();
    this.indexByUsers(this.lisChek);
    this.activitiesList(this.lisChek);
  }

  //AnswerListController

  activitiesList(id: number) {
    this.AnswerListService.activitiesList(id)
      .then((data) => {
        const res: any = data;
        this.answerLists = res.data;
        console.log(res.data);
      })
      .catch((error) => console.log(error));
  }

  answerLisDeleteList(id) {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.AnswerListService.eliminarAnswerList(id).then((data) => {
      const resp: any = data;
      if (resp.success === false) {
        swal({
          title: "Mensaje ",
          text: resp.message,
          type: "error",
        });
      } else {
        swal({
          title: "Tercero agregado",
          type: "success",
        });
        this.activitiesList(this.lisChek);
      }
    });
  }

  AnswerListCreate() {
    if (!this.answerForm.invalid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
      this.AnswerListService.AnswerListCreate(
        Number(this.answerForm.get("id").value),
        this.answerForm.get("name").value,
        this.lisChek
      )
        .then((data) => {
          const resp: any = data;

          if (resp.success === false) {
            console.log(resp.message);
            swal({
              title: "Mensaje ",
              text: resp.message.nameList,
              type: "error",
            });
          } else {
            swal({
              title: "Tercero agregado",
              type: "success",
              text: resp.message,
            });
            this.activitiesList(this.lisChek);
            this.clearForm();
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    }
  }
  //AnswerListController

  //CheckListUsersControllera
  index(id: number) {
    this.AnswerListService.activitiesList(id)
      .then((data) => {
        const res: any = data;
        console.log(res.data);
      })
      .catch((error) => console.log(error));
  }

  getUser() {
    this.UserService.getUsers()
      .then((data) => {
        const resp: any = data;
        this.userSelects = resp.data;
        //console.log("Aca Data de user", data);
        //console.log("Aca Data de userSelects", this.userSelects);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  indexByUsers(id: number) {
    this.ChecklisAreatService.indexByUsers(id).then((data) => {
      const rest: any = data;
      this.userLists = rest.data;
      console.log("data de tqabla", this.userLists);
    });
  }

  validateRestCheckList() {
    if (!this.addUserForm.invalid) {
      const idUser = Number(this.addUserForm.get("idUser").value);
      const center = this.addUserForm.get("center").value;
      const place = this.addUserForm.get("place").value;
      const passingDate = this.addUserForm.get("passingDate").value;
      const listChek = this.lisChek;
      // swal({
      //   title: "Validando información ...",
      //   allowOutsideClick: false,
      // });
      // swal.showLoading();
      /*
      this.ChecklisAreatService.validateRestCheckList(
        Number(this.addUserForm.get("idUser").value),
        this.addUserForm.get("center").value,
        this.addUserForm.get("place").value,
        this.addUserForm.get("passingDate").value,
        this.lisChek
      )
        .then((data) => {
          const resp: any = data;

          if (resp.success === false) {
            console.log(resp.message);
            swal({
              title: "Mensaje ",
              text: resp.message.nameList,
              type: "error",
            });
          } else {
            swal({
              title: "Tercero agregado",
              type: "success",
              text: resp.message,
            });

            this.indexByUsers(this.lisChek);
            this.clearForm();
          }
        })
        .catch((error) => {
          // console.log(error);
        }); */
    }
  }

  activateDeactivate(id: number) {
    this.ChecklisAreatService.activateDeactivate(id).then((data) => {
      console.log(data);
      this.indexByUsers(this.lisChek);
    });
  }
  //CheckListUsersController
  //*********** (i) Administrar listas de chequeo  *************** */

  indexByIdArea(id: number) {
    this.ChecklisAreatService.indexByIdArea(id)
      .then((data) => {
        const resp: any = data;
        this.checklists = resp.data;
        console.log("aca data checklist para pasar!", this.checklists);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  managearea(id) {
    this.router.navigateByUrl("erp/questionsCheck/" + id);
    localStorage.setItem("ariali", id);
  }

  clearForm() {
    this.addUserForm.reset();
  }

  getCustomers() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.restService
      .getCustomer()
      .then((data) => {
        const resp: any = data;
        console.log(data);
        swal.close();
        this.customers = resp.data;
        console.log("Acaaa customers", this.customers);
        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getBranchOffices() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    console.log("Acaaaa Data de branch");
    console.log(this.addUserForm.value);
    console.log("id de la empresa", this.addUserForm.value.selectedBusinessId);
    //const selectedBusinessId = this.addUserForm.get("selectedBusinessId");
    const selectedBusinessId = this.addUserForm.value.selectedBusinessId;
    console.log("Cliente seleccionado ID:", selectedBusinessId);

    this.restService
      .getOffice(selectedBusinessId)
      .then((data) => {
        const resp: any = data;
        //console.log("oficinas: " + data);

        this.branchOffices = resp.data;
        console.log("Acaaa data de sedes", this.branchOffices);
        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //// el submit es validateRestCheckList
  sendCheckAssing() {
    if (this.addUserForm.valid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      if (this.addUserForm.get('dateRange').value && !this.addUserForm.get('untilDate').value) {
        swal({
          title: "Error ",
          text: "Debe diligenciar los campos Obligatorios",
          type: "error",
        });
        return;
      }

      const idUser = Number(this.addUserForm.get("idUser").value);

      const place = this.addUserForm.get("place").value;
      const passingDate = this.addUserForm.get("passingDate").value;
      const untilDate = this.addUserForm.get("untilDate").value;
      const listChek = this.lisChek;

      const selectedBusinessId = Number(
        this.addUserForm.get("selectedBusinessId").value
      );

      const selectedBranchOfficeId = Number(
        this.addUserForm.get("selectedBranchOfficeId").value
      );
      const selectedCustomer = this.customers.find(
        (customer) => customer.id === selectedBusinessId
      );
      const customerName = selectedCustomer
        ? selectedCustomer.business_name
        : "N/A";

      ///Buscar correo cliente

      const userSelected = this.userSelects.find((user) => user.id === idUser);
      const userEmail = userSelected.email;
      console.warn("Acaaa Email donde se debe enviar", userEmail);

      // Buscar la sede seleccionada por su ID
      const selectedBranchOffice = this.branchOffices.find(
        (branchOffice) => branchOffice.id === selectedBranchOfficeId
      );
      const branchOfficeName = selectedBranchOffice
        ? selectedBranchOffice.branch_name
        : "N/A";

      console.log(
        "Acaaa nombres de empresa y ramas",
        customerName,
        branchOfficeName
      );
      const company = customerName;
      const center = branchOfficeName;

      const DataEmail = {
        empresa: customerName,
        place: place,
        center: center,
        passingDate: passingDate,
        untilDate: untilDate,
        checklists: this.checklists,
      };
      console.log("Acaaa DataEmail", DataEmail);
      this.ChecklisAreatService.sendCheckAssing(
        idUser,
        center,
        place,
        passingDate,
        untilDate,
        listChek,
        company
      )

        .then((data) => {
          const resp: any = data;

          if (resp.success === false) {
            console.log(resp.message);
            swal({
              title: "Mensaje ",
              text: resp.message.nameList,
              type: "error",
            });
          } else {
            swal({
              title: "Tercero agregado",
              type: "success",
              text: resp.message,
            });
            this.sendEmailNotification(DataEmail, userEmail);

            // this.indexByUsers(this.lisChek);
            this.clearForm();
            this.indexByUsers(this.lisChek);
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    } else {
      //console.warn("Malo el formulario");
      swal({
        title: "Error ",
        text: "Debe diligenciar los campos Obligatorios",
        type: "error",
      });
    }
  }

  sendEmailNotification(DataEmail, userEmail) {
    console.log("Acaaa email para enviar desde func", userEmail);
    console.log("Acaaa Data para enviar desde func", DataEmail);

    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    //Indico el email de notificacion (cartera y el correo cliente)

    const updateData: any = {
      emails: [userEmail],

      notificationData: DataEmail,
    };
    console.log("Data pasada para correo simultaneo:", updateData);
    console.log("Holaaa desde donde mando correo", updateData);
    this.ChecklisAreatService.sendEmailNotificationInspectionAssing(updateData)
      .then(() => {
        console.log("Correcto, se envio el correo para De despacho de items");
        swal({
          title: "Se envio el correo",
          type: "success",
        });
        this.ngOnInit();
        this.clearForm();
      })
      .catch((error) => {
        // Manejar el error en caso de que la promesa sea rechazada
        console.error("Error al enviar notificaciones por correo:", error);
      });
  }

  onClickDateRangeCheckbox() {
    this.addUserForm.patchValue({
      passingDate: '',
      untilDate: ''
    });
  }

  ////
}



// WEBPACK FOOTER //
// ./src/app/master/master-answer-list/master-answer-list.component.ts